 const Constant ={

     Role :{
        ADMIN :"ADMIN",
        SUPER_ADMIN : "SUPER_ADMIN",
        USER : "USER",
        WAREHOUSE : "WAREHOUSE"
      },

      RequestType :{
        ORDER_REQUEST : "ORDER_REQUEST",
        SAMPLE_REQUEST : "SAMPLE_REQUEST",
        OFFER_REQUEST : "OFFER_REQUEST",
        SELL_REQUEST : "SELL_REQUEST",
        CUSTOMER_SERVICE_REQUEST : "CUSTOMER_SERVICE_REQUEST",
      },

      OrderStatus :{
        CART : "CART",
        PENDING_REVIEW : "PENDING_REVIEW",
        ACCEPTED : "ACCEPTED",
        REJECTED : "REJECTED",
        SHIPPED : "SHIPPED",
        CANCELLED : "CANCELLED",
        DELIVERED : "DELIVERED",
        SELLER_REJECTED: "SELLER_REJECTED",
        ADMIN_REJECTED: "ADMIN_REJECTED",
        IN_TRANSIT : "IN_TRANSIT",
        OWNERSHIP_TRANSFERRED : "OWNERSHIP_TRANSFERRED",
        CLOSED : "CLOSED",
        SEND_TO_WAREHOUSE: "SEND_TO_WAREHOUSE",
        IN_PROCESS: "IN_PROCESS",
        REASSIGN_TO_ADMIN: "REASSIGN_TO_ADMIN",
        ADMIN_ACCEPTED_FOR_WAREHOUSE: "ADMIN_ACCEPTED_FOR_WAREHOUSE",
        WAREHOUSE_COMPLETED: "WAREHOUSE_COMPLETED"
      },

      SampleRequestStatus :{
        PENDING_REVIEW : "PENDING_REVIEW",
        UNDER_REVIEW : "UNDER_REVIEW",
        ACCEPTED : "ACCEPTED",
        REJECTED : "REJECTED", 
        APPROVED : "APPROVED",
        ACTION_REQUIRED : "ACTION_REQUIRED",
        IN_TRANSIT : "IN_TRANSIT",
        CANCELLED : "CANCELLED",
        SEND_TO_WAREHOUSE: "SEND_TO_WAREHOUSE",
        IN_PROCESS: "IN_PROCESS",
        REASSIGN_TO_ADMIN: "REASSIGN_TO_ADMIN",
        ADMIN_ACCEPTED_FOR_WAREHOUSE: "ADMIN_ACCEPTED_FOR_WAREHOUSE",
        WAREHOUSE_COMPLETED: "WAREHOUSE_COMPLETED"        
      },

      CustomerServiceRequestStatus : {
        PENDING_REVIEW : "PENDING_REVIEW",
        UNDER_REVIEW : "UNDER_REVIEW",
        ACCEPTED : "ACCEPTED",
        REJECTED : "REJECTED",
        CANCELLED : "CANCELLED",
        CLOSED: "CLOSED",
        PUBLISHED: "PUBLISHED",
        OWNERSHIP_TRANSFERRED: "OWNERSHIP_TRANSFERRED",
        UPLOADED: "UPLOADED",
        UPLOADING: "UPLOADING",
        PROCESSING: "PROCESSING",
        UPLOAD_FAILED: "UPLOAD_FAILED",
        FAILED: "FAILED",
        SOLD: "SOLD",
        COMPLETED: "COMPLETED",
        ASSIGNED: "ASSIGNED",
        UNPUBLISHED: "UNPUBLISHED",
        REPUBLISHED: "REPUBLISHED",
        DELETED: "DELETED",
        IN_TRANSIT: "IN_TRANSIT",
        ADMIN_ACCEPTED: "ADMIN_ACCEPTED",
        ADMIN_REJECTED: "ADMIN_REJECTED",
        IN_PROGRESS: "IN_PROGRESS",
        INVOICE_SENT: "INVOICE_SENT",
        DELIVERED: "DELIVERED",
        PAYMENT_RECEIVED: "PAYMENT_RECEIVED",
        RE_PROCESSING: "RE_PROCESSING",
        SEND_TO_OWNER: "SEND_TO_OWNER",
        SEND_TO_WAREHOUSE: "SEND_TO_WAREHOUSE",
        IN_PROCESS: "IN_PROCESS",
        REASSIGN_TO_ADMIN: "REASSIGN_TO_ADMIN",
        CONFIRMED_FOR_WAREHOUSE: "CONFIRMED_FOR_WAREHOUSE",
        IN_STAGE_FOR_WAREHOUSE: "IN_STAGE_FOR_WAREHOUSE",
        ADMIN_ACCEPTED_FOR_WAREHOUSE: "ADMIN_ACCEPTED_FOR_WAREHOUSE",
        WAREHOUSE_COMPLETED: "WAREHOUSE_COMPLETED",    
        CONFIRMED: "CONFIRMED",
        IN_STAGE: "IN_STAGE",
        SCHEDULED: "SCHEDULED",
        SOURCE_ACCEPTED: "SOURCE_ACCEPTED",
        SOURCE_REJECTED: "SOURCE_REJECTED",
        DESTINATION_ACCEPTED: "DESTINATION_ACCEPTED",
        DESTINATION_REJECTED: "DESTINATION_REJECTED",
        RE_OPEN: "RE_OPEN"
      },

      LOCATION : {
        STAGING: "In Staging",
        WAREHOUSE: "In Rack"
      },

      LogisticRequest : {
        INBOUND: "Inbound",
        OUTBOUND: "Outbound",
        EXTERNAL: "External"
      },

      ContractStatus : {
        ACTIVE : "ACTIVE",
        EXPIRED : "EXPIRED"
      },

      facility : {
        WHITEDOG_TRADING_STORAGE : "WhiteDog Trading Storage",
        WDTS : "WDTS",
      } ,

      warehouse : {
        WDTS_WH1 : "WDTS WH1",
        WDTS_WH2 : "WDTS WH2",
        WDTS_WH3 : "WDTS WH3",
        WDTS_WH4 : "WDTS WH4"
      },

      Profile : {
        OWNER : 'Owner',
        BUYER : 'Buyer'
      },

      SyncType : {
        KEGHOUND_TO_WHITEDOG : 'KEGHOUND_TO_WHITEDOG',
        WHITEDOG_TO_KEGHOUND : 'WHITEDOG_TO_KEGHOUND'
      },

      BarrelSource : {
        SHIP_BY_SELECTING_BARRELS : 'Manual Barrel Selection',
        SHIP_BY_SELECTING_REQUEST : 'Logistic from Existing Request',
        SHIP_BY_UPLOAD_INVENTORY : 'Upload Inventory for Logistic'
      },

      CustomerService : {
        PRIVATE_SELL : 'Private Sale',
        BULK_INVENTORY_UPLOAD : 'Bulk Inventory Upload',
        OWNERSHIP_TRANSFER: "Ownership Transfer",
        SELL_REQUEST: "Sell Request",
        BARREL_PROOFING: "Barrel Proofing",
        BARREL_OWNER_ASSIGNMENT: "Barrel Owner Assignment",
        SAMPLE_REQUEST: "Sample Request",
        LOGISTIC : "Logistic",
        CUSTOM_SAMPLE_REQUEST: "Custom Sample Request",
        RE_CONTAINERIZATION : "Re-Containerization",
        BARREL_HEAD_PAINTING: "Barrel Head Painting",
        TASTING: "Tasting",
        BARREL_REPAIR_REQUEST: "Barrel Repair Request",
        BLENDING_REQUEST: "Blending Request",
        BOTTLING_REQUEST: "Bottling Request",
        DUMPING_REQUEST: "Dumping Request",
        BARREL_VALUATION: "Barrel Valuation",
        WANTED_TO_BUY: "Wanted to Buy",
      },

      Field : {
        DESCRIPTION : 'Description',
        PRICE : 'Price',
        COMMISSION_FEE :  'Commission Fee',
        FEE_TYPE : 'Fee Type',
        REQUESTING_ORGANIZATION: 'Requesting Organization',
        COMPANY_OWNS_INVENTORY: 'Does the account owner own the uploaded inventory?',
        INVENTORY_AT_THIRD_PARTY: 'Are inventories stored at 3rd party facility?',
        RECEIVING_COMPANY: 'Receiving Account Owner',
        NEW_COMPANY: 'New Account Owner',
        DATE_OF_TRANSFER: "Date of Transfer"
      },

      FIELD_TYPES : {
        COMPANY_DROPDOWN: "company_dropdown",
        USER_DROPDOWN: "user_dropdown",
        ADD_INVENTORY: "add_inventory",
        ADD_CONTAINER: "add_container",
        PRODUCT_DROPDOWN: "product_dropdown",
        FEE_TYPE_DROPDOWN: "fee_type_dropdown",
        PRICE: "price",
        QUANTITY: "quantity",
        NUMBER: "number",
        RADIO: "radio",
        TEXT: "text",
        COMMENT: "comment",
        RICH_TEXT: "rich_text",
        DATE: "date",
        UPLOAD_DOC: "upload_doc",
        UPLOAD_FILE: "upload_file",
        CURRENT_USER: "current_user",
        CURRENT_COMPANY: "current_company",
        SIZE_DROPDOWN: "size_dropdown",
        PURPOSE_DROPDOWN: "purpose_dropdown",
        CONTACT_NUMBER: "contact_number",
        EMAIL: "email",
        PRIVATE_BUYER_COMPANY: "private_buyer_company",
        PRIVATE_BUYER_USER: "private_buyer_user",
        CARRIER: "carrier",
        COMMISSION_FEE: "commission_fee",
        OWNER_DROPDOWN: "owner_dropdown",
        OWNER_NAME_DROPDOWN: "owner_name_dropdown",
        TRANSFER_REQUEST_DROPDOWN: "transfer_request_dropdown",
        CONTAINER_TYPE_DROPDOWN: "container_type_dropdown",
        AGE_START: "age_start",
        AGE_END: "age_end",
        PROOFING_MIN: "proofing_min",
        PROOFIND_MAX: "proofing_max",
        MASH_BILL: "mash_bill",
        SHIP_FROM_ADDRESS: "ship_from_address",
        SHIP_TO_ADDRESS: "ship_to_address",
        LOGISTIC_TYPE_DROPDOWN: "logistic_type_dropdown",
        SOURCE_CONTAINER: "source_container",
        SHIP_FROM_DSP: "ship_from_dsp",
        SHIP_TO_DSP: "ship_to_dsp",
        SHIP_FROM_CONTACT: "ship_from_contact",
        SHIP_TO_CONTACT: "ship_to_contact",
        SHIP_FROM_FACILITY: "ship_from_facility",
        SHIP_TO_FACILITY: "ship_to_facility",
        // Add other field types here
      },

      SIGNUP_POPUP_TYPE : {
        SUCCESS: "REQUESTED",
        PENDING_REVIEW: "PENDING_REVIEW",
        REJECTED: "REJECTED"
      },
      max_container_allowed_per_customer_service_request: 5000
}


export default Constant;